import { banksSelector } from './banksSelector';
import { IApplicationState } from '../types/redux';

export const hasBanksSelector = (state: IApplicationState): boolean => {
  const banks = banksSelector(state);

  return banks.length > 0;
};
